module.exports = __webpack_public_path__ + "static/media/_ships.f6ca8fe7.svg";